import { DigitalBrochureRequestModel, formDigitalBrochure } from '@bpd-library/utilities';

interface RequestBrochureData {
    additionalPdfs?: string;
    email: string;
    firstName: string;
    lastNamePrefix?: string;
    lastName: string;
    areaProjectId: string;
    projectPhaseId: string;
    propertyTypeId?: string | null;
    constructionNumberId?: string | null;
    pageUrl: string; // Custom url that should be generated by BE
}

const requestBrochure = async ({
    additionalPdfs,
    email,
    firstName,
    lastNamePrefix,
    lastName,
    areaProjectId,
    projectPhaseId,
    propertyTypeId,
    constructionNumberId,
    pageUrl,
}: RequestBrochureData) => {
    const data: DigitalBrochureRequestModel = {
        data: additionalPdfs,
        email,
        firstName,
        sufix: lastNamePrefix,
        lastName,
        pageUrl,
        areaId: areaProjectId,
        projectId: projectPhaseId,
        propertyId: propertyTypeId,
        constructionNumberId,
    };

    try {
        await formDigitalBrochure(data);
    } catch (error) {
        console.error(error);
    }
};

export { requestBrochure, RequestBrochureData };
